/* ============================================================
   LA MAISON COURBE — Interactions
   ============================================================ */

(function () {
  'use strict';

  /* ---------- Header au scroll ---------- */
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 40);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Menu mobile ---------- */
  var burger = document.querySelector('[data-burger]');
  var nav = document.querySelector('[data-nav]');
  if (burger && nav) {
    burger.addEventListener('click', function () {
      burger.classList.toggle('is-open');
      nav.classList.toggle('is-open');
      document.body.style.overflow = nav.classList.contains('is-open') ? 'hidden' : '';
    });
    nav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        burger.classList.remove('is-open');
        nav.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    });
  }

  /* ---------- Reveal au scroll ---------- */
  var revealEls = document.querySelectorAll('.mc-reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(function (el) { observer.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- Parallaxe douce sur les bannières ---------- */
  var banners = document.querySelectorAll('[data-parallax]');
  if (banners.length) {
    var raf = null;
    var updateParallax = function () {
      banners.forEach(function (bg) {
        var rect = bg.parentElement.getBoundingClientRect();
        var progress = (rect.top + rect.height / 2 - window.innerHeight / 2) / window.innerHeight;
        bg.style.transform = 'translateY(' + (progress * 14).toFixed(2) + '%)';
      });
      raf = null;
    };
    window.addEventListener('scroll', function () {
      if (!raf) raf = requestAnimationFrame(updateParallax);
    }, { passive: true });
    updateParallax();
  }

  /* ---------- Tilt léger sur les cartes produits ---------- */
  document.querySelectorAll('[data-tilt]').forEach(function (card) {
    card.addEventListener('mousemove', function (e) {
      var r = card.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5;
      var y = (e.clientY - r.top) / r.height - 0.5;
      card.style.transform = 'perspective(900px) rotateY(' + (x * 4) + 'deg) rotateX(' + (-y * 4) + 'deg)';
    });
    card.addEventListener('mouseleave', function () {
      card.style.transform = 'perspective(900px) rotateY(0deg) rotateX(0deg)';
    });
  });
})();
